<app-login-layout header="Please confirm your information">
  @if (error()) {
    <div class="alert alert-danger" role="alert">{{ error() }}</div>
  }
  <form (ngSubmit)="onSubmit()">
    <formly-form [form]="form" [fields]="formFields" [model]="currentUser()" />
    <div class="pt-2">
      <chitin-button label="Confirm" (clicked)="onSubmit()" [isLoading]="isSending()" data-cy="submitBtn" />
    </div>
  </form>
</app-login-layout>
